export default __webpack_public_path__ + "static/media/delete.60baf523.svg";